import React from 'react'
import PropTypes from 'prop-types'

const InteractionCounters = ({ total, today, participantCount }) => {
  const hasParticipants = participantCount > 0

  return (
    <div className='br-interactions col-xs-12'>
      <div className='row'>
        <div
          className={`br-interaction-counter col-xs-${hasParticipants ? 4 : 6}`}
        >
          <div className='uppercase font-hg font-blue'>{total}</div>
          <div className='font-grey-mint font-sm'>Total Interactions</div>
        </div>
        <div
          className={`br-interaction-counter col-xs-${hasParticipants ? 4 : 6}`}
        >
          <div className='uppercase font-hg theme-font'>{today}</div>
          <div className='font-grey-mint font-sm'>Interactions Today</div>
        </div>
        {hasParticipants ? (
          <div className='br-interaction-counter col-xs-4'>
            <div className='uppercase font-hg theme-font'>
              {participantCount}
            </div>
            <div className='font-grey-mint font-sm'>Participants</div>
          </div>
        ) : null}
      </div>
    </div>
  )
}

InteractionCounters.propTypes = {
  total: PropTypes.number.isRequired,
  today: PropTypes.number.isRequired,
  participantCount: PropTypes.number.isRequired
}

InteractionCounters.displayName = 'InteractionCountersComponent'

export default InteractionCounters



// WEBPACK FOOTER //
// ./src/pages/my-experiences/experience/interaction-counters/index.js